import numeral from 'numeral';

import { getFormatString } from './utils';

export function getHumanReadableCount(num: number) {
  let formatString = getFormatString({ decimals: 0, comma: true });
  return numeral(num).format(formatString);
}
